export enum PbhCarrierType {
  None = 0,
  DHL = 1,
  FedEx = 2,
  TKCargo = 3,
  Other = 4,
}

export const GetPbhCarrierType = [
  // { Description: "None", Value: PbhCarrierType.None },
  { Description: "DHL", Value: PbhCarrierType.DHL },
  { Description: "FedEx", Value: PbhCarrierType.FedEx },
  { Description: "Turkish Cargo", Value: PbhCarrierType.TKCargo },
  { Description: "Other", Value: PbhCarrierType.Other },
];
